mutation (
  $input: NewsletterApplicationInput!
) {
  sendNewsletterApplication(
    input: $input
  )
}
